import { Controller } from "@hotwired/stimulus"

// The funnel in an analytics table's column header (TMS-1229). It sits inside a
// <th> that sorts on click, so every click here is stopped before the header
// sees it — otherwise opening the filter would also re-sort the table.
//
// The input it reveals belongs to the enclosing data-table controller (it is
// that controller's `search` or `columnFilter` target); this one only shows,
// hides and clears it.
export default class extends Controller {
  static targets = ["toggle", "input"]

  stop(event) {
    event.stopPropagation()
  }

  toggle() {
    this.inputTarget.hidden ? this.open() : this.close()
  }

  keydown(event) {
    if (event.key !== "Escape") return

    event.preventDefault()
    this.clear()
    this.close()
    this.toggleTarget.focus()
  }

  open() {
    this.inputTarget.hidden = false
    this.toggleTarget.setAttribute("aria-expanded", "true")
    this.inputTarget.focus()
  }

  close() {
    this.inputTarget.hidden = true
    this.toggleTarget.setAttribute("aria-expanded", "false")
    this.toggleTarget.classList.toggle("is-active", this.inputTarget.value !== "")
  }

  clear() {
    if (this.inputTarget.value === "") return

    this.inputTarget.value = ""
    // The data-table controller listens for the same events a person would fire.
    const eventName = this.inputTarget.tagName === "SELECT" ? "change" : "input"
    this.inputTarget.dispatchEvent(new Event(eventName, { bubbles: true }))
  }
}
